module.exports = __webpack_public_path__ + "static/media/sedo_output.57d615b6.csv";